export enum USER_UPDATE_ACTION {
  UPDATE_EDUCATOR_EMAIL = "UPDATE_EDUCATOR_EMAIL",
  UPDATE_PROFILE = "UPDATE_PROFILE",
}
